module.exports = __webpack_public_path__ + "static/img/LUIS_URREA.4ca83f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/LUIS_URREA.jpg
// module id = Vbty
// module chunks = 1